<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Rawat Jalan" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Gagal Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <DetailTop v-if="detailTop" :detailTop="detailTop" />
          <div class="row mb-4" v-if="detailLeftTop || detailRightTop">
            <div class="col-md-7 pr-1" v-if="detailLeftTop">
              <DetailLeft :detailLeftTop="detailLeftTop" />
            </div>
            <div class="col-md-5 pl-1" v-if="detailRightTop">
              <DetailRight :detailRightTop="detailRightTop" />
            </div>
          </div>
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <div class="row">
            <div class="col-md-6">
              <h5 class="text-uppercase text-info mb-3">data rawat jalan</h5>
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
            <div class="col-md-6">
              <FormRow
                v-for="row in rightForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-10" style="position: relative">
              <hr />
              <div class="d-flex flex-between mt-4 mb-3">
                <h5 class="mb-2">Diagnosa</h5>
              </div>
              <div class="form-group">
                <div class="row">
                  <div class="col-md-12">
                    <div class="input-group">
                      <input
                        type="text"
                        :class="
                          'form-control form-control-lg pl-5 with-icon-left without-label ' +
                            (isError ? 'error' : '')
                        "
                        placeholder="Cari kode atau nama klasifikasi medis"
                        @input="
                          (e) => {
                            a_medical = false;
                            s_medical = e.target.value;
                            updateForm();
                          }
                        "
                        :value="s_medical"
                        v-on:keyup.enter="() => search('medical')"
                      />
                      <i
                        class="material-symbols-outlined"
                        style="margin-top: -0.25rem"
                        >search</i
                      >
                      <div class="input-group-append">
                        <button
                          class="btn btn-secondary btn-with-icon-left"
                          @click="() => search('medical')"
                        >
                          <i class="material-symbols-outlined">search</i>
                          CARI
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <SearchResultMedical
                @addItem="(item) => addItem(item, 'medical')"
                v-if="s_medical && a_medical"
                :loading="l_medical"
                :data="r_medical"
              />
              <table
                class="responsive"
                v-if="medical.filter((item) => !item.deleted).length"
              >
                <thead>
                  <th>KODE</th>
                  <th>KLASIFIKASI MEDIS</th>
                  <th>DESKRIPSI</th>
                  <th></th>
                </thead>
                <tbody>
                  <tr
                    v-for="item in medical.filter((item) => !item.deleted)"
                    v-bind:key="item.id + Math.random(1024)"
                  >
                    <td>
                      {{
                        item.tipe +
                          " " +
                          item.kode +
                          (item.subkode ? `.${item.subkode}` : "")
                      }}
                    </td>
                    <td>{{ item.desc_short }}</td>
                    <td>{{ item.desc_long }}</td>
                    <td>
                      <button
                        class="btn btn-icon btn-danger btn-sm"
                        @click="() => deleteItem('medical', item.id)"
                        v-if="item.status != 'DIBATALKAN'"
                      >
                        <i class="material-symbols-outlined">delete</i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="handleForm"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  Simpan Data Pemeriksaan
                </button>
                <!-- <router-link
                  class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                  to="/ralan"
                  >Batalkan</router-link
                > -->
                <a
                  class="
                    btn btn-outline-danger btn-no-outline
                    float-right
                    text-uppercase
                  "
                  @click="() => goBack('/ralan')"
                  >Batalkan
                </a>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Alert from "@/components/Alert.vue";
import SearchResultMedical from "@/components/SearchResultMedical.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import DetailTop from "@/components/DetailTop.vue";
import DetailLeft from "@/components/DetailLeft.vue";
import DetailRight from "@/components/DetailRight.vue";
import {
  setPatientIntro,
  setRawatIntro,
  validateForms,
  convertSize,
} from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { leftForm, rightForm, today, time } from "@/data/RalanFormDokter.js";

export default {
  name: "RalanFormDokter",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    DetailTop,
    DetailLeft,
    DetailRight,
    Alert,
    SearchResultMedical,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: {
        title: "Ubah Data Pemeriksaan Dokter",
        backBtn: "",
        actionBtn: [],
        breadcrumb: [
          { title: "Detail Rawat Jalan", link: "" },
          { title: "Ubah Data Pemeriksaan Dokter", active: true },
        ],
      },
      leftForm: leftForm,
      rightForm: rightForm,
      idFormDoc: "",
      detailTop: null,
      detailLeftTop: null,
      detailRightTop: null,
      fisikLama: "",
      formSet: {
        no_rawat: "",
        id_dokter: "",
        tgl_periksa: today,
        jam_periksa: time,
        fisik: null,
        dx_utama: "",
        dx_sekunder: "",
        medis: "",
        soap: "",
      },
      saveSuccess: false,
      saveFailed: false,
      s_medical: "",
      r_medical: [],
      medical: [],
      a_medical: false,
      l_medical: false,
      isError: false,
    };
  },
  methods: {
    goBack(url) {
      // //console.log(this.fromUrl);
      let urlArray = this.fromUrl.split("?");
      let backBtn = urlArray[0];
      // //console.log(backBtn);
      // //console.log(window.history.back);

      if (
        !backBtn ||
        this.fromUrl.indexOf("form") > -1 ||
        this.fromUrl.indexOf("edit") > -1 ||
        this.fromUrl.indexOf("cetak") > -1
      ) {
        if (url)
          this.$router.push({
            path:
              url +
              (this.$route.query.fromTab
                ? "?tab=" + this.$route.query.fromTab
                : ""),
          });
        else this.$router.go(-1);
      } else if (this.$route.query.fromTab) {
        let queryString = "?";
        let tabQuery = "tab=" + this.$route.query.fromTab;
        if (urlArray[1]) {
          if (urlArray[1].toLowerCase().indexOf(tabQuery.toLowerCase()) < 0) {
            if (urlArray[1].indexOf("tab=") > -1) {
              let queryArray = urlArray[1].split("tab=");
              if (queryArray[1]) {
                let restQueryArray = queryArray[1].split("&");
                restQueryArray[0] = this.$route.query.fromTab;
                queryArray[1] = restQueryArray.join("&");
              }
              urlArray[1] = queryArray.join("tab=");
            } else {
              queryString += tabQuery + "&";
            }
          }
          queryString += urlArray[1];
        } else {
          queryString += tabQuery;
        }
        // //console.log(backBtn)
        this.$router.push({ path: backBtn + queryString });
      } else {
        // //console.log(window.history);
        let queryString = "";
        if (urlArray[1]) {
          queryString += "?" + urlArray[1];
        }
        this.$router.push({ path: backBtn + queryString });
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(`/ralan/detail/${that.$route.params.id}`);
        }, 1000);
      }
    },
    fetchMedical: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `ralan/pemeriksaan/medical?no_rawat=${this.formSet["no_rawat"]}`
        );
        //console.log(result);
        let self = this;
        if (result.status == "200") {
          self.medical = [];
          result.data.forEach((item) => {
            item.nama = item.periksamedical.nama;
            item.kode = item.periksamedical.kode;
            item.id_ralan_medical = item.id;
            item.id = item.periksamedical.id;
            self.medical = self.medical.concat(item);
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;

      let url;
      if (type == "medical") {
        url = "penyakit";
      } else {
        url = "tindakan";
      }
      try {
        let result = await this.$store.state.HTTP.get(
          // `${url}?per_page=10`
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          this["r_" + type] = result.data;
          this["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          this["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      let found = false;
      this[type] = this[type].map((el) => {
        if (el.id == item.id) {
          el.deleted = false;
          found = true;
        }
        return el;
      });
      if (!found) {
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
    handleForm: async function() {
      this.errors = [];
      let formData = new FormData();
      var self = this;
      // let body="";

      let medical = this.medical.filter((item) => !item.deleted);
      let valid = this.validateForm() && medical.length;
      if (!medical.length) {
        alert("Diagnosa Wajib diisi!");
      }
      if (valid) {
        medical.forEach(async function(item, index) {
          //console.log(item.id);
          formData.append(`id_penyakit[${index}]`, item.id);
        });
        Object.keys(this.formSet).forEach(function(key) {
          if (self.formSet[key]) {
            if (!(key == "fisik" && self.formSet[key] == self.fisikLama)) {
              formData.append(key, self.formSet[key]);
            }
          }
          // body+=`&${key}=${self.formSet[key]}`;
        });
        try {
          let result = await this.$store.state.HTTP.post(
            `/ralan/pemeriksaan/dokter/${this.idFormDoc}`,
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.saveFailed = false;
            this.saveSuccess = true;
            var that = this;
            setTimeout(function() {
              that.saveSuccess = false;
              that.$router.push(`/ralan/detail/${that.$route.params.id}`);
            }, 1000);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
            this.saveFailed = true;
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
          this.saveFailed = true;
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        this.formSet[e.target.name] = e.target.value;
      }
    },

    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      [this.leftForm, this.rightForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              !column.optional &&
              column.type != "hidden" &&
              !self.formSet[column.name]
            ) {
              valid = false;
              column.error = "Kolom ini wajib diisi";
            } else {
              column.error = "";
            }
            if (column.type == "image") {
              if (self.formSet[column.name] != self.fisikLama) {
                //console.log(self.formSet[column.name]);
                var reader = new FileReader();
                reader.onload = function(e) {
                  column.value = e.target.result;
                  self.leftForm.map((item) => {
                    item.columns = item.columns.map((column) => {
                      return column;
                    });
                    return item;
                  });
                };
                // Cek ukuran file
                let size = self.formSet[column.name].size;
                //console.log(size);
                // Jika pada input ditentukan size maksimal, gunakan size pada input, jika tidak, gunakan default max size 10MB
                let maxSize = column.maxSize
                  ? parseInt(column.maxSize)
                  : 10485760;
                if (size > maxSize) {
                  valid = false;
                  column.error = `Melebihi ukuran maksimal file ${convertSize(
                    maxSize
                  )}`;
                }
                reader.readAsDataURL(self.formSet[column.name]);
              } else {
                self.formSet[column.name];
                //console.log(column.value);
                //console.log(self.fisikLama);
              }
            } else {
              if (self.formSet[column.name]) {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      // this.leftForm = forms[0];
      // this.rightForm = forms[1];
      setTimeout(function() {
        // ////console.log('berhasil masuk ke awal sini');
        self.leftForm.map((item) => {
          item.columns = item.columns.map((column) => {
            column.key = Math.random();
            return column;
          });
          return item;
        });
        // ////console.log('berhasil masuk ke akhir sini');
      }, 2000);
      //console.log(self.formSet);
      return valid;
    },
    fetchNurses: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `petugas?per_page=9999999999`
        );
        //console.log(result);
        if (result.status == "200") {
          this.upperForm[0].columns[2].options = result.data.data.map(
            (item) => {
              return { value: item.id, label: item.nama };
            }
          );
        } else {
          this.displayNotFoundError();
        }
      } catch (e) {
        //console.log(e);
      }
    },
    displayData: async function(data) {
      let self = this;
      //console.log(data);
      this.idFormDoc = data.id;
      let result = await this.$store.state.HTTP.get(
        `ralan/pemeriksaan/dokter/${this.idFormDoc}`
      );
      //console.log(result);
      this.medical = result.data.rln_periksa_dok_penyakit.map((item) => {
        return item.penyakit;
      });
      Object.keys(this.formSet).forEach(function(key) {
        if (key == "fisik") {
          // self.formSet[key]=data['formatted_fisik'];
          // self.fisikLama = data['formatted_fisik'];
          if (data["formatted_fisik"]) {
            self.formSet[key] = data["formatted_fisik"].replace(/ /g, "%20");
            self.fisikLama = data["formatted_fisik"].replace(/ /g, "%20");
          }
        } else {
          self.formSet[key] = data[key];
        }
      });
      //console.log(self.formSet);
      this.updateForm();
    },

    updateForm: function() {
      let self = this;
      let forms = [this.leftForm, this.rightForm].map(function(form) {
        form = form.map(function(row) {
          row.columns = row.columns.map(function(column) {
            if (
              (self.formSet[column.name] &&
                self.formSet[column.name] != null &&
                self.formSet[column.name] != "null") ||
              self.formSet[column.name] == 0
            ) {
              if (
                ["file", "image"].indexOf(column.type) > -1 &&
                self.formSet[column.name] != self.fisikLama
              ) {
                // column.value = '';
                self.updateImage(self.formSet[column.name], column);
              } else {
                column.value = self.formSet[column.name];
              }
            }
            return column;
          });
          return row;
        });
        return form;
      });
      this.leftForm = forms[0];
      this.rightForm = forms[1];
    },
    updateImage: async function(file, column) {
      let rowIndex = 1;
      column.value = await new Promise((resolve) => {
        var reader = new FileReader();
        reader.onload = (e) => resolve(reader.result);
        reader.readAsDataURL(file);
      });
      ////console.log(column.value);
      ////console.log(this.leftForm);
      this.leftForm.splice(rowIndex, 1, this.leftForm[rowIndex]);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.data.backBtn = "/ralan/detail/" + this.$route.params.id;
    this.data.breadcrumb[0].link = "/ralan/detail/" + this.$route.params.id;
    try {
      let result = await this.$store.state.HTTP.get(
        `ralan/${this.$route.params.id}?darurat=0`
      );
      //console.log(result);
      if (result.status == "200") {
        //console.log('ralan');
        //console.log(result.data);
        this.detailTop = setPatientIntro(result.data.pasien);
        let detailRawat = setRawatIntro(result.data);
        if (result.data.jen_periksa == "Kontrol Lanjutan") {
          this.rightForm[3].columns[0].type = "textarea";
        } else {
          this.rightForm[3].columns[0].type = "hidden";
        }
        // this.displayData(result.data.rln_periksa_dok);
        if (result.data.rln_periksa_dok) {
          this.displayData(result.data.rln_periksa_dok);
        } else {
          this.$router.push(`/ralan/form-dokter/${this.$route.params.id}`);
        }
        this.detailLeftTop = detailRawat.detailLeftTop;
        this.detailRightTop = detailRawat.detailRightTop;
        //console.log('ralan');
        this.formSet["no_rawat"] = result.data.no_rawat;
        this.formSet["id_dokter"] = result.data.id_dokter;
        //console.log(this.formSet['no_rawat']);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }

    // this.fetchNurses();
  },
};
</script>
